import { render, staticRenderFns } from "./el-button.vue?vue&type=template&id=5d31704e&"
import script from "./el-button.vue?vue&type=script&lang=js&"
export * from "./el-button.vue?vue&type=script&lang=js&"
import style0 from "./el-button.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports